import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AddQuestion from "./AddQuestion";
import { DialogBox } from "../../../../components/Elements/DialogBox";
const QuestionDialog = ({ onOpen, onClose, formId }) => {
  const navigate = useNavigate();
  const [openAddQuestion, setOpenAddQuestion] = useState(false);

  const handleOpenAddQuestion = () => {
    setOpenAddQuestion(true);
  };

  return (
    <>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <h3 className="text-2xl font-bold">Select Question Form</h3>

        <div className="space-y-4 mt-4 border px-4 py-8">
          <div
            className="w-full border px-4 py-3 rounded-lg cursor-pointer hover:bg-gray-100"
            onClick={() =>
              navigate(`/organization/add-questions/${formId.id}`, {
                state: { formTitle: formId.title },
              })
            }
          >
            <p className="text-lg">Offset Question Bank</p>
          </div>

          <div
            className="w-full border px-4 py-3 rounded-lg cursor-pointer hover:bg-gray-100"
            onClick={() =>
              navigate(`/organization/add-manualquestions/${formId.id}`, {
                state: { formTitle: formId.title },
              })
            }
          >
            <p className="text-lg">Manually Question</p>
          </div>
        </div>
      </DialogBox>

      {openAddQuestion && (
        <AddQuestion
          onOpen={openAddQuestion}
          onClose={() => setOpenAddQuestion(false)}
        />
      )}
    </>
  );
};

export default QuestionDialog;
